// redux\reducers\dashboardLayoutSlice.ts

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { DashboardLayoutMenuDetail } from "@/app/types/alterNativeDashboardLayout";

interface DashboardLayoutState {
  layoutId: number | null;
  layoutName: string | null;
  menuDetail: DashboardLayoutMenuDetail[];
  loading: boolean;
  error: string | null;
}

const initialState: DashboardLayoutState = {
  layoutId: null,
  layoutName: null,
  menuDetail: [],
  loading: false,
  error: null,
};

const dashboardLayoutSlice = createSlice({
  name: "dashboardLayout",
  initialState,
  reducers: {
    setDashboardLayoutLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setDashboardLayoutView(
      state,
      action: PayloadAction<{
        layoutId: number;
        layoutName: string;
        menuDetail: DashboardLayoutMenuDetail[];
      }>,
    ) {

      state.layoutId = action.payload.layoutId;
      state.layoutName = action.payload.layoutName;
      state.menuDetail = action.payload.menuDetail;
      state.error = null;
    },
    setDashboardLayoutError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    resetDashboardLayout(state) {

      state.layoutId = null;
      state.layoutName = null;
      state.menuDetail = [];
      state.error = null;
    },
  },
});


export const {
  setDashboardLayoutLoading,
  setDashboardLayoutView,
  setDashboardLayoutError,
  resetDashboardLayout,
} = dashboardLayoutSlice.actions;

export default dashboardLayoutSlice.reducer;
